module.exports = __webpack_public_path__ + "img/g3-label.6785610f.svg";